export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'What exactly is ready in 72 hours?',
    answer:
      'The full site shell and structure — live and viewable, built for your business. Adding your final photos, exact wording, and small tweaks happens after, fast, through Slack.',
  },
  {
    question: 'Is there a contract?',
    answer: '3-month minimum term on all packages.',
  },
  {
    question: 'What if I pay by ACH or check instead of card?',
    answer:
      'Pricing shown is the card price and includes standard processing. ACH and check are a different rate — email results@getadroi.com for details.',
  },
]
